export default __webpack_public_path__ + "static/media/p8.9d434a86.jpg";